import * as React from "react";
const IconLayoutAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57 2H7C4.2 2 2 4.2 2 7v27.2c0 2.8 2.2 5 5 5h50c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5m3 32.2c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3zM55.4 49.2H8.6c-.6 0-1 .4-1 1s.4 1 1 1h46.8c.6 0 1-.4 1-1s-.4-1-1-1M55.4 60H8.6c-.6 0-1 .4-1 1s.4 1 1 1h46.8c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconLayoutAlt;
